/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Cost_PriceInputs */

const vi_report_inventory_cost_price = /** @type {(inputs: Report_Inventory_Cost_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá vốn`)
};

/**

* @param {Report_Inventory_Cost_PriceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_cost_price = /** @type {((inputs?: Report_Inventory_Cost_PriceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Cost_PriceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_cost_price(inputs)
});